import { createIcon, Icon, IconProps } from '@oaknorth/component-core-v2';

const IconSVG = createIcon({
  path: (
    <g clipPath="url(#clip0_2212_997)">
      <path
        d="M94.3439 83.9543H6.84387C3.39804 83.9543 0.593872 81.1502 0.593872 77.7043V23.5377C0.593872 20.0918 3.39804 17.2877 6.84387 17.2877H94.3439C97.7897 17.2877 100.594 20.0918 100.594 23.5377V77.7043C100.594 81.1502 97.7897 83.9543 94.3439 83.9543ZM6.84387 21.4543C5.69387 21.4543 4.76054 22.3877 4.76054 23.5377V77.7043C4.76054 78.8543 5.69387 79.7877 6.84387 79.7877H94.3439C95.4939 79.7877 96.4272 78.8543 96.4272 77.7043V23.5377C96.4272 22.3877 95.4939 21.4543 94.3439 21.4543H6.84387Z"
        fill="currentColor"
      />
      <path
        d="M69.3439 100.621H31.8439C30.6939 100.621 29.7606 99.6877 29.7606 98.5377C29.7606 97.3877 30.6939 96.4543 31.8439 96.4543H69.3439C70.4939 96.4543 71.4272 97.3877 71.4272 98.5377C71.4272 99.6877 70.4939 100.621 69.3439 100.621Z"
        fill="currentColor"
      />
      <path
        d="M44.3439 100.621C43.1939 100.621 42.2606 99.6877 42.2606 98.5377V81.871C42.2606 80.721 43.1939 79.7877 44.3439 79.7877C45.4939 79.7877 46.4272 80.721 46.4272 81.871V98.5377C46.4272 99.6877 45.4939 100.621 44.3439 100.621Z"
        fill="currentColor"
      />
      <path
        d="M56.8439 100.621C55.6939 100.621 54.7606 99.6877 54.7606 98.5377V81.871C54.7606 80.721 55.6939 79.7877 56.8439 79.7877C57.9939 79.7877 58.9272 80.721 58.9272 81.871V98.5377C58.9272 99.6877 57.9939 100.621 56.8439 100.621Z"
        fill="currentColor"
      />
      <path
        d="M42.2605 67.2876C41.473 67.2876 40.7522 66.846 40.398 66.1376L32.6397 50.621H23.5105C22.3605 50.621 21.4272 49.6876 21.4272 48.5376C21.4272 47.3876 22.3605 46.4543 23.5105 46.4543H33.9272C34.7147 46.4543 35.4355 46.9001 35.7897 47.6043L42.1147 60.2543L52.8439 35.2168C53.1647 34.471 53.8855 33.9793 54.698 33.9543C55.5105 33.9626 56.2605 34.3793 56.623 35.1043L68.548 58.9543H77.6772C78.8272 58.9543 79.7605 59.8876 79.7605 61.0376C79.7605 62.1876 78.8272 63.121 77.6772 63.121H67.2605C66.473 63.121 65.7522 62.6751 65.398 61.971L54.9064 40.9876L44.1772 66.0251C43.8564 66.771 43.1355 67.2626 42.323 67.2876C42.3022 67.2876 42.2814 67.2876 42.2605 67.2876Z"
        fill="currentColor"
      />
    </g>
  ),
});

export function ONPortfolioMonitoringLogo(props: IconProps) {
  return (
    <Icon {...props}>
      <IconSVG />
    </Icon>
  );
}
